"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMakeBulletResult = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateMakeBulletResult = (0, validation_1.properties)({
    dummy: (0, validation_1.text)(),
});
//# sourceMappingURL=MakeBulletResult.js.map